import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PaginatedList } from '../models/shared/paginated-list.model';
import { OrderModel } from '../models/order.model';
import { GetOrdersRequest, OrderSortBy } from '../models/shared/order-sort.model';
import { SortDirection } from '../models/shared/base-request.model';
import { ClientOrderProductModel } from '../models/client-order-product.model';
import { CreateOrderRequest } from '../models/create-order-request.model';
@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  private readonly apiUrl = `${environment.apiUrl}/api/orders`;
  constructor(private http: HttpClient) {
  }
  getOrders(pageNumber: number = 1, search: string = '', filters: string[] = [], pageSize: number = 10, sortBy: OrderSortBy = 'OrderProgress', sortDirection: SortDirection = 'Ascending'): Observable<PaginatedList<OrderModel>> {
    const request: GetOrdersRequest = { search, pageNumber, filters, pageSize, sortBy, sortDirection };
    let params = new HttpParams()
      .set('search', request.search)
      .set('pageNumber', request.pageNumber)
      .set('pageSize', request.pageSize)
      .set('sortBy', request.sortBy)
      .set('sortDirection', request.sortDirection);
    request.filters?.forEach(filter => {
      params = params.append('filters', filter);
    });
    return this.http.get<PaginatedList<OrderModel>>(`${this.apiUrl}/getOrders`, { params });
  }
  getAvailableProducts(): Observable<ClientOrderProductModel[]> {
    return this.http.get<ClientOrderProductModel[]>(`${this.apiUrl}/getAvailableProducts`);
  }
  createOrder(request: CreateOrderRequest): Observable<OrderModel> {
    return this.http.post<OrderModel>(`${this.apiUrl}/createOrder`, request);
  }
  getOrderDetails(id: string): Observable<OrderModel> { return this.http.get<OrderModel>(`${this.apiUrl}/${id}/details`); }
  getOrder(id: string): Observable<OrderModel> {
    return this.http.get<OrderModel>(`${this.apiUrl}/${id}`);
  }
  updateOrder(id: string, request: CreateOrderRequest): Observable<OrderModel> {
    return this.http.put<OrderModel>(`${this.apiUrl}/${id}`, request);
  }
  deleteOrder(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
